import { imageFromUuid } from '../../helpers/utility';
import malePic from "../../assets/images/patient_male.png";
import femalePic from "../../assets/images/patient_female.png";


const ImgHolder = ({ uuid }) => {
    
    const imageKey = typeof uuid === 'string' ? uuid.toLowerCase() : uuid;
    let url = '';

    if(imageKey == 'female'){
        url = femalePic
    }
    else if(imageKey == 'male'){
        url = malePic
    }
    else {
        url = imageFromUuid(uuid);
    }

  return (
    <img src={url} className="h-full w-full rounded-full object-cover" alt="" />
  );
};

export default ImgHolder;